import { render, staticRenderFns } from "./InnerTable.vue?vue&type=template&id=11a2fa24&scoped=true&"
import script from "./InnerTable.vue?vue&type=script&lang=js&"
export * from "./InnerTable.vue?vue&type=script&lang=js&"
import style0 from "./InnerTable.vue?vue&type=style&index=0&id=11a2fa24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a2fa24",
  null
  
)

export default component.exports